import { onLCP, onCLS, onINP, onFCP, onTTFB } from 'web-vitals';

let vueInstance = null;

function sendMetric(metric) {
  const isDevelopment = window.pov_config.VUE_APP_ENV === 'development';
  const connection = navigator.connection;

  const eventData = {
    value: metric.value,
    rating: metric.rating,
    'event category': 'Web Vitals',
    'page URL': window.location.href,
    'page title': document.title,
    source: 'pov',
    navigationType: metric.navigationType,
    'user agent': navigator.userAgent,
    'connection type': connection?.effectiveType || 'unknown',
    'connection downlink': connection?.downlink || null,
    'connection rtt': connection?.rtt || null,
  };
  
  if (isDevelopment) {
    console.log(`POV - webVitals - ${metric.name}`, {
      value: `${metric.value}ms`,
      rating: metric.rating,
      ...eventData,
    });
  } else if (vueInstance.$track) {
    vueInstance.$track(metric.name, eventData);
  } else {
    console.warn('POV - webVitals - $track not available, cannot send metric');
  }
}

export function initWebVitals(app) {
  vueInstance = app;
  
  const isDevelopment = window.pov_config.VUE_APP_ENV === 'development';
    
  const reportAllChanges = isDevelopment;

  onLCP(sendMetric, { reportAllChanges });
  onCLS(sendMetric, { reportAllChanges });
  onINP(sendMetric, { reportAllChanges });
  onFCP(sendMetric, { reportAllChanges });
  onTTFB(sendMetric, { reportAllChanges });
}

export default {
  initWebVitals,
};
